module.exports = __webpack_public_path__ + "img/magic-stick-top-white.748b1a45.svg";